<script>
  import IconButton from '@smui/icon-button';
  import { navigate } from 'svelte-routing';
</script>

<IconButton
  id="add-institution-button"
  title="Add Institution"
  class="material-icons gigxr-icon-button"
  on:click={() => navigate('/institutions/create')}
>
  add_box
</IconButton>

<style>
</style>
